import lfRequest from '@/service/index'

export function getGenerateLink(linkId: string) {
  return lfRequest.post<any[]>({
    url: `/main/fuboGenerate/generate/h5/${linkId}`
  })
}
